module.exports = __webpack_public_path__ + "img/arrow-collapse.6c828ae1.svg";